// «Не найдено» — только когда сервер так и ответил. Сеть, таймаут, 5xx или
// протухший токен — временная ошибка: повторяем запрос, а не показываем 404
// для страницы, которая есть.

export function httpStatus(error: unknown): number | undefined {
  return (error as { response?: { status?: number } } | null)?.response?.status;
}

/** The server says this thing doesn't exist (or the id in the URL is malformed). */
export function isNotFoundError(error: unknown): boolean {
  const s = httpStatus(error);
  return s === 404 || s === 410 || s === 400;
}

/** React Query `retry`: client errors are final, anything else gets up to 2 more tries. */
export function retryTransient(failureCount: number, error: unknown): boolean {
  const s = httpStatus(error);
  if (s && s >= 400 && s < 500 && s !== 408 && s !== 429) return false;
  return failureCount < 2;
}
